export const ru = {
    locale: 'ru',
    likert: {
        'lik.mind.1': 'Прежде чем сближаться с кем-то, я стараюсь понять, какая семья мне нужна.',
        'lik.mind.2': 'Если человек мне сильно нравится, его недостатки перестают меня беспокоить.',
        'lik.mind.3': 'Я могу отойти от человека, который мне нравится, если наши взгляды на жизнь не совпали.',
        'lik.mind.4': 'Решения о близких отношениях я принимаю по тому, что чувствую в моменте.',
        'lik.mind.5': 'Я могу назвать два-три качества, без которых не стану строить семью.',
        'lik.ready.1': 'Я читал(а) книги или проходил(а) обучение об отношениях и семье.',
        'lik.ready.2': 'Я представляю, как будет устроен наш быт в первый год после свадьбы.',
        'lik.ready.3': 'Про семейную жизнь я думаю так: поженимся — там разберёмся.',
        'lik.ready.4': 'Я расспрашивал(а) семейных людей о том, что их удивило после свадьбы.',
        'lik.ready.5': 'Я знаю, какие свои привычки мне придётся менять, когда я стану жить вдвоём.',
        'lik.mission.1': 'Я могу объяснить словами, чему хочу посвятить свою жизнь.',
        'lik.mission.2': 'Я занимаюсь делом, которым занимался(ась) бы, даже если бы за него не платили.',
        'lik.mission.3': 'Мне трудно сказать, где я вижу себя через десять лет.',
        'lik.mission.4': 'У меня есть цель, ради которой я готов(а) рано вставать и уставать.',
        'lik.mission.5': 'Я пробую разное, но пока не нашёл(нашла) своего.',
        'lik.role.1': 'У меня есть свой путь, и я не откажусь от него ради семьи.',
        'lik.role.2': 'Я вижу себя опорой человека, у которого есть своё большое дело.',
        'lik.role.3': 'Я готов(а) переехать в другой город ради дела моей пары.',
        'lik.role.4': 'Мне важно, чтобы моя пара поддерживала мой путь, а не тянула в свою сторону.',
        'lik.role.5': 'Мне важнее, чтобы получилось у моей пары, чем чтобы получилось у меня.',
        'lik.home.1': 'Обеспечивать семью деньгами — дело мужчины.',
        'lik.home.2': 'Хозяйство и заработок правильно делить между двоими поровну.',
        'lik.home.3': 'Мне ближе семья, где у мужа и жены разные обязанности, а не одинаковые.',
        'lik.home.4': 'Если работают оба, то и ужин, и посуда делятся по очереди.',
        'lik.home.5': 'Жена может работать, но зарабатывать на дом — не её задача.',
        'lik.kin.1': 'Жить вместе с родителями — своими или пары — для меня нормально.',
        'lik.kin.2': 'Первые годы семье лучше жить отдельно, чтобы встать на ноги.',
        'lik.kin.3': 'Родители могут участвовать в решениях нашей семьи.',
        'lik.kin.4': 'Я готов(а) взять родителей к себе, когда им станет трудно.',
        'lik.kin.5': 'То, что происходит между мной и парой, не должно обсуждаться с роднёй.',
        'lik.resp.1': 'Когда в отношениях плохо, я жду, что вторая сторона начнёт первой.',
        'lik.resp.2': 'Если у нас не ладится, я сначала смотрю, что могу изменить я.',
        'lik.resp.3': 'Счастье семьи наполовину зависит от меня, наполовину от партнёра.',
        'lik.resp.4': 'Я иду мириться первым(ой), даже когда виноват(а) не я.',
        'lik.resp.5': 'Я могу долго ждать, что человек сам поймёт, чего мне не хватает.',
        'lik.accept.1': 'Я рассчитываю, что после свадьбы смогу изменить некоторые привычки моей пары.',
        'lik.accept.2': 'Я принимаю человека вместе с тем, что мне в нём не нравится.',
        'lik.accept.3': 'Если человек пообещает измениться ради меня, я поверю и буду ждать.',
        'lik.accept.4': 'Я не стану строить семью с человеком в надежде, что он станет другим.',
        'lik.accept.5': 'Мне кажется, что я смог(ла) бы воспитать свою пару.',
    },
    likertScale: ['Почти никогда', 'Редко', 'Иногда', 'Обычно', 'Почти всегда'],
    likertHints: ['это совсем не про меня', '', 'по обстоятельствам', '', 'это точно про меня'],
    axes: {
        mind: {
            name: 'Как я выбираю пару',
            left: 'Иду за чувством',
            right: 'Считаю и взвешиваю',
            hi: 'Вы взвешиваете. Заранее знаете, какие качества для вас непроходные, и способны отойти от человека, который нравится, если главное не совпало.',
            mid: 'У вас работают и чувство, и расчёт. Зона внимания — не отдать решающий голос чувству в самый горячий момент.',
            lo: 'Вы идёте за чувством: симпатия для вас важнее списка условий. Решение, принятое на пике влюблённости, чаще всего пересматривают потом.',
        },
        ready: {
            name: 'Подготовка к семейной жизни',
            left: 'Разберусь по ходу',
            right: 'Готовлюсь заранее',
            hi: 'Вы готовитесь осознанно: читаете, спрашиваете, представляете быт заранее. Это самая недооценённая часть — и вы её делаете.',
            mid: 'Вы кое-что продумали, но многое оставили «на потом». Полугода подготовки обычно хватает, чтобы закрыть основное.',
            lo: 'Вы рассчитываете разобраться по ходу. Это работает ровно до первого серьёзного столкновения — дальше приходится учиться на живых отношениях.',
        },
        mission: {
            name: 'Своё дело и направление в жизни',
            left: 'Ещё ищу своё дело',
            right: 'Знаю, куда иду',
            hi: 'У вас есть дело и направление, которое вы можете объяснить словами. Это опора и для вас, и для пары.',
            mid: 'Направление нащупано, но контуры размыты. Стоит проверить: чем вы занимались бы, даже если бы за это не платили?',
            lo: 'Вы ещё в поиске своего. Это не минус — но паре важно знать, что рядом с ней человек в пути, а не в готовой точке.',
        },
        role: {
            name: 'Роль в паре: свой путь или опора',
            left: 'Я — опора для пары',
            right: 'У меня свой путь',
            hi: 'Свой путь. Вы не готовы растворяться в чужом деле, и вам нужен человек, который это уважает.',
            mid: 'Вы видите две дороги, идущие рядом: у каждого своё, направление общее.',
            lo: 'Опора. Вам важнее, чтобы получилось у вашей пары; вы готовы вкладываться в чужое дело как в своё.',
        },
        home: {
            name: 'Уклад дома: быт и деньги',
            left: 'Делим всё пополам',
            right: 'Разные роли у мужа и жены',
            hi: 'Традиционный уклад: обязанности мужа и жены разные, зарабатывать на дом — задача мужчины.',
            mid: 'Смешанный уклад — часть пополам, часть по ролям. Именно здесь чаще всего возникают взаимные обиды: границу нужно проговорить, а не подразумевать.',
            lo: 'Партнёрский уклад: деньги, кухня и хлопоты делятся между двоими примерно поровну.',
        },
        kin: {
            name: 'Родня и границы семьи',
            left: 'Мы живём отдельно от родни',
            right: 'Родня внутри нашей семьи',
            hi: 'Родня — часть вашей семьи: жить рядом, участвовать в решениях, взять родителей к себе для вас нормально.',
            mid: 'Вы держите родню близко, но не во всём. Полезно назвать вслух, что именно решается только вдвоём.',
            lo: 'Ваша семья — отдельный контур. Родителей вы любите, но решения принимаете вдвоём и внутрь не пускаете.',
        },
        resp: {
            name: 'Ответственность за отношения',
            left: 'Жду первого шага от второго',
            right: 'Беру первый шаг на себя',
            hi: 'Вы берёте ответственность на себя целиком и идёте мириться первым. Это и есть ключ к прочности семьи.',
            mid: 'Вы делите ответственность пополам — «половина от меня, половина от него». Эта формула коварна: обе половины ждут друг друга, и не двигается никто.',
            lo: 'Вы склонны ждать, что вторая сторона начнёт первой. Это как зал ожидания: оба сидят и ждут рейса, который никто не объявляет.',
        },
        accept: {
            name: 'Принятие человека как есть',
            left: 'Рассчитываю переделать',
            right: 'Принимаю как есть',
            hi: 'Вы принимаете человека вместе с тем, что вам в нём не нравится, и не строите план перевоспитания.',
            mid: 'Вы принимаете многое, но кое-что рассчитываете «подправить». Стоит честно назвать, что именно, — и проверить, готовы ли вы жить с этим, если оно не изменится.',
            lo: 'Вы рассчитываете изменить человека после свадьбы. Это самая частая ошибка: устают оба, а обещания, данные до свадьбы, каждый понимал по-своему.',
        },
    },
    conditions: {
        faith: { title: 'Религия', hint: 'Вера, обряды, намаз, пост — насколько это должно совпадать.' },
        language: { title: 'Язык в семье', hint: 'На каком языке вы будете говорить дома и учить детей.' },
        origin: { title: 'Нация и род', hint: 'Происхождение вашей пары, регион, родословная.' },
        age: { title: 'Возраст', hint: 'Старше, младше, ровесник — насколько это принципиально.' },
        education: { title: 'Образование', hint: 'Высшее образование и то, насколько человек действительно учился.' },
        past: { title: 'Прошлый брак и дети', hint: 'Был ли человек в браке раньше, есть ли ребёнок.' },
        looks: { title: 'Внешность и вкус', hint: 'Как человек выглядит, следит ли за собой, как одевается.' },
        wealth: { title: 'Достаток и жильё', hint: 'Доход, своя квартира, финансовая устойчивость к свадьбе.' },
        separateHome: { title: 'Жить отдельно от родителей', hint: 'Отдельный дом с первого дня — или как получится.' },
        children: { title: 'Дети: когда и сколько', hint: 'Сроки, количество, готовность вообще их иметь.' },
        wifeCareer: { title: 'Работа и карьера жены', hint: 'Будет ли жена работать и чьи это деньги.' },
        geography: { title: 'Где жить', hint: 'Город, аул, переезд в другую страну.' },
    },
    levels: ['Принципиально', 'Важно', 'Желательно'],
    levelHints: [
        'без этого не буду строить семью',
        'важно, но могу закрыть глаза',
        'приятно, если есть; не решает',
    ],
    forks: {
        live: {
            title: 'Родители зовут жить вместе после свадьбы.',
            options: ['Соглашаюсь — так правильно', 'Живём отдельно, это решено', 'Решаем вдвоём и вместе говорим родителям'],
        },
        money: {
            title: 'Зарплата жены.',
            options: ['Идёт в общий семейный бюджет', 'Остаётся у неё', 'Решаем вдвоём каждый месяц'],
        },
        whoDecides: {
            title: 'Кто решает, когда невестка едет к своим родным.',
            options: ['Согласовывается со свекровью', 'Только муж и жена вдвоём', 'По ситуации, жёсткого правила нет'],
        },
        wedding: {
            title: 'Свадьба.',
            options: ['Большая, по всем обычаям', 'Скромная — деньги на старт семьи', 'Средняя, как решат родители'],
        },
        conflict: {
            title: 'Первый серьёзный конфликт.',
            options: ['Говорю сразу, пока не остыло', 'Беру паузу, потом обсуждаю', 'Жду, пока само уляжется'],
        },
        cooled: {
            title: 'Через год чувства остыли.',
            options: ['Идём к специалисту', 'Разбираемся вдвоём', 'Это нормально, так у всех'],
        },
    },
    self: {
        'self.age': { title: 'Сколько вам лет?', hint: '', placeholder: 'например, 24' },
        'self.city': { title: 'Где вы живёте?', hint: 'Город или аул — как назовёте сами.', placeholder: 'например, Алматы' },
        'self.faith': { title: 'Религия в вашей жизни', hint: 'Выберите строку, которая ближе всего к правде.' },
        'self.lang': { title: 'Казахский язык у вас', hint: '' },
        'self.edu': { title: 'Ваше образование', hint: '' },
        'self.past': { title: 'Вы были в браке?', hint: '' },
        'self.field': { title: 'Ваше дело', hint: 'Сфера, в которой вы работаете или учитесь.' },
    },
    want: {
        'want.faith': {
            title: 'Религиозность вашей пары',
            hint: 'Ниже какого уровня вы не пойдёте.',
            options: [
                'Не ниже: относится отрицательно',
                'Не ниже: ей всё равно',
                'Не ниже: уважает, но обрядов не исполняет',
                'Не ниже: исполняет некоторые обряды',
                'Не ниже: религия — образ жизни',
                'Не ниже: религия — смысл жизни',
                'Не важно',
            ],
        },
        'want.lang': {
            title: 'Казахский язык у вашей пары',
            hint: '',
            options: [
                'Не ниже: не любит и учить не хочет',
                'Не ниже: совсем не понимает',
                'Не ниже: понимает, но не говорит',
                'Не ниже: говорит, но думает на другом',
                'Не ниже: говорит и думает на казахском',
                'Не ниже: мыслит только на казахском',
                'Не важно',
            ],
        },
        'want.age': {
            title: 'Возраст вашей пары',
            hint: '',
            options: ['Младше меня', 'Ровесник — разница до трёх лет', 'Старше меня', 'Не важно'],
        },
        'want.edu': {
            title: 'Образование вашей пары',
            hint: '',
            options: ['Высшее, и человек действительно учился', 'Достаточно, чтобы был диплом', 'Не важно'],
        },
        'want.past': {
            title: 'Прошлый брак вашей пары',
            hint: '',
            options: [
                'Только тот, кто не был в браке',
                'Был брак — приму, но без детей',
                'Приму и с ребёнком',
                'Не важно',
            ],
        },
        'want.geo': {
            title: 'Где вы готовы жить',
            hint: '',
            options: ['Только в моём городе', 'Готов(а) переехать за парой', 'Только в городе, не в ауле', 'Не важно'],
        },
    },
    scales: {
        faith: [
            'Отношусь к религии отрицательно',
            'Мне всё равно, есть она или нет',
            'Уважаю, но обрядов не исполняю',
            'Исполняю некоторые обряды',
            'Религия — мой образ жизни',
            'Религия — смысл моей жизни',
        ],
        lang: [
            'Казахский не люблю и учить не хочу',
            'Совсем не понимаю по-казахски',
            'Понимаю, но говорить не могу',
            'Говорю, но думаю на другом языке',
            'Говорю и думаю на казахском',
            'Всё мышление сформировано на казахском',
        ],
        edu: [
            'Учился(ась) по-настоящему, знаю своё дело',
            'Диплом есть, но специальность знаю слабо',
            'Высшего образования нет',
        ],
        past: ['В браке не был(а)', 'Был(а), детей нет', 'Был(а), есть ребёнок', 'Вдовец / вдова'],
        field: [
            'Наука и образование',
            'Бизнес и своё дело',
            'Госслужба',
            'Медицина',
            'IT и техника',
            'Творчество и искусство',
            'Спорт',
            'Религиозная сфера',
            'Рабочая специальность',
            'Дом, семья, дети',
            'Ещё ищу своё',
        ],
        anyValue: 'Не важно',
    },
    zones: {
        'zone.cond.clash': '«{cond}»: для одного это принципиально, для другого — лишь желательно. Для одного из вас это то, без чего семьи не будет, для второго — необязательная деталь.',
        'zone.cond.differ': '«{cond}»: разный вес. Один считает это важным, второй — второстепенным.',
        'zone.cond.bothStem': '«{cond}» — принципиально для обоих. Совпало в самом главном.',
        'zone.axis.critical': '«{axis}»: расхождение {delta} пунктов. Уклад, роли и границы с роднёй дают больше всего ссор в первый год.',
        'zone.axis.differ': '«{axis}»: смотрите по-разному. Не критично, но стоит проговорить.',
        'zone.axis.same': '«{axis}» — вы совпадаете.',
        'zone.flag.wantsToChange': 'Расчёт переделать человека. Самая частая ошибка: обещания, данные до свадьбы, каждый понимает по-своему, а устают оба.',
        'zone.flag.bothWaiting': 'Оба ждут хода от второго. «Зал ожидания»: двое сидят и ждут рейса, который никто не объявит.',
        'zone.flag.unprepared': 'Ни один из вас не готовился. Не приговор — просто впереди полгода, которые стоит потратить с толком.',
        'zone.fork.heavy': '{fork}: вы отвечаете по-разному, и это про деньги или родню — самые частые причины ссор.',
        'zone.fork.light': '{fork}: ответы разошлись.',
        'zone.nothingMajor': 'Крупных расхождений не нашлось. Это не значит, что говорить не о чем: пройдите карту условий вслух, пункт за пунктом.',
    },
    gates: {
        'gate.age': 'Возраст пары не подходит под требование ({age}).',
        'gate.level': '«{cond}» — принципиальное условие: нужно не ниже уровня {need}, у пары {has}.',
        'gate.eduReal': 'Нужен человек, который действительно учился.',
        'gate.eduAny': 'Нужен человек с высшим образованием.',
        'gate.pastMarried': 'Принимает только тех, кто не был в браке.',
        'gate.pastChild': 'Не готов(а) принять ребёнка от прошлого брака.',
        'gate.geography': 'Разные города ({cityA} и {cityB}), и оба не готовы переезжать.',
    },
    flags: {
        'flag.wantsToChange': 'Рассчитывает переделать пару',
        'flag.waiting': 'Ждёт хода от второго',
        'flag.unprepared': 'Не готовился',
        'flag.bothWaiting': 'Оба ждут хода от второго',
    },
    reasons: {
        'why.home.same': 'Уклад дома совпадает: одинаково смотрят на роли и деньги.',
        'why.kin.same': 'Одинаково смотрят на родню и границы семьи.',
        'why.role.strong': 'Модель ролей устойчивая: {model}.',
        'why.cond.same': 'Совпало {count} условий из 12 по уровню важности.',
        'why.fork.money': 'Одинаково отвечают на все три денежно-родственные развилки.',
        'why.field.same': 'Одно поле деятельности.',
        'why.home.differ': 'Уклад дома видят по-разному: один ждёт разных ролей, другой — «пополам».',
        'why.kin.differ': 'Расходятся в том, насколько родня участвует в жизни семьи.',
        'why.role.weak': 'Роли складываются неудачно: {model}.',
        'why.cond.clash': 'Условий, где у одного «принципиально», а у другого «желательно»: {count}. Это темы для разговора в первую очередь.',
        'why.fork.differ': '{fork}: ответы расходятся.',
    },
    roleModels: {
        leaderSupport: {
            label: 'ведущий и опора',
            note: 'Один идёт своей дорогой, второй — его опора. Самая устойчивая из моделей.',
        },
        sideBySide: {
            label: 'идут рядом',
            note: 'Две дороги в одну сторону: у каждого своё дело, направление общее.',
        },
        apart: {
            label: 'две дороги врозь',
            note: 'Оба не готовы уступать своему пути. Самая шаткая расстановка: общего интереса нет.',
        },
        bothSupport: {
            label: 'обе опоры',
            note: 'Оба готовы поддерживать — но никто не ведёт. Придётся решать, чьё дело в семье главное.',
        },
        mixed: {
            label: 'смешанная',
            note: 'Роли распределятся, но границу лучше проговорить заранее.',
        },
    },
    talk: {
        'talk.home.1': 'Кто зарабатывает на дом в первый год и что будет, если доход упадёт?',
        'talk.home.2': 'Кто готовит и моет посуду в будний вечер, когда оба вернулись с работы?',
        'talk.home.3': 'Что каждый считает «обязанностью жены» и «обязанностью мужа» — назовите по три пункта вслух.',
        'talk.kin.1': 'Живём с родителями или отдельно — и с какого дня?',
        'talk.kin.2': 'Какие решения принимаются только вдвоём, без родни?',
        'talk.kin.3': 'Кто говорит с родителями, когда те не согласны, — сын или невестка?',
        'talk.role.1': 'Чьё дело в ближайшие пять лет главное и почему?',
        'talk.role.2': 'Готов(а) ли ты переехать ради дела второго?',
        'talk.role.3': 'Что каждый из вас теряет, если пойдёт за другим?',
        'talk.mind.1': 'Что вы почувствовали, когда впервые подумали о свадьбе, — и что об этом думаете на холодную голову?',
        'talk.mind.2': 'Какие условия каждый назвал «стволом» — сверьте списки.',
        'talk.mind.3': 'От чего каждый готов отказаться ради главного?',
        'talk.ready.1': 'Что вы оба сделаете за ближайшие полгода, чтобы подготовиться, — конкретно?',
        'talk.ready.2': 'У кого спросите совета из тех, кто прожил вместе десять лет?',
        'talk.ready.3': 'Какие свои привычки каждый готов менять?',
        'talk.mission.1': 'Чем каждый из вас занимался бы, даже если бы за это не платили?',
        'talk.mission.2': 'Где вы оба видите себя через десять лет — в одном месте?',
        'talk.mission.3': 'Что для каждого важнее: дело или семья, если придётся выбирать?',
        'talk.resp.1': 'Кто обычно делает первый шаг к примирению у вас двоих?',
        'talk.resp.2': 'Что каждый готов сделать сам, не дожидаясь второго?',
        'talk.resp.3': 'Как вы поймёте, что пора идти за помощью?',
        'talk.accept.1': 'Что в другом ты надеешься со временем изменить? Назови вслух.',
        'talk.accept.2': 'Сможешь ли ты жить с этим, если оно не изменится никогда?',
        'talk.accept.3': 'Что каждый просит принять в себе как есть?',
        'talk.cond.1': 'Что именно ты вкладываешь в этот пункт — назови конкретно.',
        'talk.cond.2': 'Что произойдёт, если сделать по-твоему? А если по-моему?',
    },
    parts: {
        1: 'Как я устроен(а)',
        2: 'Мои условия',
        3: 'Развилки',
        4: 'О себе',
        5: 'Чего жду от пары',
    },
    push: {
        // Имя здесь уместно: эти двое связаны приглашением и знают друг друга.
        'pair.accepted': {
            title: 'Приглашение принято',
            body: '{name} принял(а) вашу ссылку. Отчёт соберётся, когда тест пройдут оба.',
        },
        // Приглашение принял тот, кто тест уже прошёл: обе новости сразу и одним
        // пушем. Два подряд об одном и том же выглядели бы сбоем рассылки.
        'pair.accepted.ready': {
            title: 'Приглашение принято',
            body: '{name} принял(а) вашу ссылку, и разбор вашей пары уже готов.',
        },
        'pair.ready': {
            title: 'Отчёт пары готов',
            body: 'Тест прошли оба — разбор с {name} можно открыть.',
        },
        // Безлично: имени незнакомого человека на заблокированном экране не место.
        'match.sent': {
            title: 'Есть пара в подборе',
            body: 'Мы подобрали вам пару. Откройте приложение, чтобы посмотреть.',
        },
    },
};
//# sourceMappingURL=ru.js.map